import React from "react";

type ExpiryStatusProps = {
  endDate: string; // ISO string
};

const formatDate = (date: Date) => {
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  return `${day} of ${month}, ${year}`;
};

const ExpiryStatus: React.FC<ExpiryStatusProps> = ({ endDate }) => {
  const end = new Date(endDate);
  const now = new Date();

  const isExpired = end.getTime() < now.getTime();

  return (
    <div className="flex flex-col gap- text-[13px]">
      {isExpired ? (
        <>
          <span className="font-semibold text-red-600">Expired</span>
          <span className="text-gray-600 underline">
            Expired on {formatDate(end)}
          </span>
        </>
      ) : (
        <>
          <span className="font-semibold text-green-600">Active</span>
          <span className="text-gray-600 underline">
            Ends {formatDate(end)}
          </span>
        </>
      )}
    </div>
  );
};

export default ExpiryStatus;
